import { CoreSwitchGameCommunicationProcessor } from '@pp/core/src/controllers/gameCommunication/processors/CoreSwitchGameCommunicationProcessor';
import { GameCommunicationMessageType } from '@pp/core/src/controllers/gameCommunication/types';

import { highflyerStateActions } from '../../../store/slices/highflyerState/slice';

interface SwitchMessage extends GameCommunicationMessageType {
  httpAddress?: unknown;
  wsAddress?: unknown;
}
export class GameCommunicationHFSwitchProcessor extends CoreSwitchGameCommunicationProcessor {
  delay = 0;
  process(message: SwitchMessage): void {
    super.process(message);
    this.store.dispatch(highflyerStateActions.setIsServerSwitched(true));
  }
}
